import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class UploadService {

  private baseUrl = 'https://upload.icheck.vn';
  private baseUrl3 = 'https://upload.icheck.com.vn';
  private baseUrl2 = 'https://apis.icheck.vn/upload/image/v1';

  constructor(private http: HttpClient) { }

  public postImg(file: any): Observable<any> {
    // return this.http.post(`${this.baseUrl2}/raw`, body);
    
    const body = new FormData();
    body.append('my_field', 'file');
    body.append('my_file', file)
    return this.http.post(`${this.baseUrl3}/upload/stream`, body);
  }
}
